import { render, staticRenderFns } from "./CreateClientModal.vue?vue&type=template&id=1054bd76&scoped=true"
import script from "./CreateClientModal.vue?vue&type=script&lang=js"
export * from "./CreateClientModal.vue?vue&type=script&lang=js"
import style0 from "./CreateClientModal.vue?vue&type=style&index=0&id=1054bd76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1054bd76",
  null
  
)

export default component.exports